import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { ConfigComponent, FormConfigComponent, ConfigService } from "./";
import { RegrasCortesAfericaoComponent } from "./regras-cortes-afericao/regras-cortes-afericao.component";
import { FormRegrasCortesAfericaoComponent } from "./regras-cortes-afericao/form-regras-cortes-afericao/form-regras-cortes-afericao.component";
import { SystemConfigComponent } from "./system-configs/system-config.component";
import { AprovacoesMarcelinhoComponent } from "./aprovacoes-marcelinho/aprovacoes-marcelinho.component";
import { CancelamentoMassaComponent } from "./cancelamento-em-massa/cancelamento-em-massa.component";

@NgModule({
    declarations: [
        ConfigComponent,
        FormConfigComponent,
        SystemConfigComponent,
        RegrasCortesAfericaoComponent,
        FormRegrasCortesAfericaoComponent,
        AprovacoesMarcelinhoComponent,
        CancelamentoMassaComponent,
    ],
    imports: [SharedModule],
    providers: [ConfigService]
})
export class ConfigModule { }